import { useEffect, useState } from 'react';
import FooterNav from '../../components/dashboard/FooterNav';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import Main from '../../components/dashboard/Main';
import PoComponent from '../../components/dashboard/PreOrder';
import { styled } from '@mui/material/styles';
import maintenanceImg from '../../assets/maintenance.jpg';

import axios from  'axios';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";

const verifyToken = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};

const ParagraphText = styled('div')(({ theme }) => ({
    position: 'absolute',
    color: 'white',
    width: '100%',
    height: '50px',
    fontSize: '32px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    '@media only screen and (max-width:800px)': {
        fontSize: '24px'
    },
    '@media only screen and (max-width:640px)': {
        fontSize: '20px',
    },
    '@media only screen and (max-width:480px)': {
        fontSize: '18px',
    }
}));

const PreOrder = () => {
    const navigate = useNavigate();
    const [token, setToken] = useState(
        JSON.parse(localStorage.getItem('token')) !== null ? 
            JSON.parse(localStorage.getItem('token')).token :
            null
    );
    const [data, setData] = useState([]);
    const [opData, setOpData] = useState([]);
    const [cartState, setCartState] = useState([]);
    const [authData, setAuth] = useState(null);
    
    useEffect(() => {
        const refreshToken = async () => {
            console.log(token);
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/token`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                console.log(response.data.token);
                if (response.data.token) {
                    setToken(response.data.token);
                    localStorage.setItem('token', JSON.stringify(response.data));
                    await getData();
                    await getCart();
                }
                
            } catch (error) {
                console.log(token);
                // if (error.response) {
                // navigate('/');
                // }
            }
        };

        const getData = async () => {
            try {
                const polist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/list`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });
                let number = 0;
                await setData(polist.data.result.map((v) => {
                    number+=1;
                    return { ...v, no: number };
                }));

                // await getOpenedPo(polist.data.result);
            } catch (err) {
                console.log(err);
            }
        };

        const getOpenedPo = async (listed) => {
            try {
                const tobeFiltered = [];
                const filtered = [];

                listed.forEach((v) => {
                    tobeFiltered.push(v.idpoproduk);
                })

                const polist = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/opened`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });

                const poLinks = polist.data.result;
                poLinks.forEach((v) => {
                    if (!tobeFiltered.includes(v.idpoproduk)) filtered.push(v);
                })

                let number = 0;
                setOpData(filtered.map((v) => {
                    number+=1;
                    return { ...v, no: number };
                }));

            } catch (err) {
                console.log(err);
            }
        };

        const getCart = async () => {
            try {
              const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
              });
              setCartState(cartData.data.result);
            } catch (err) {
              console.log(err);
            }
        };

        const auth = async () => {
            try {
                const me = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`,
                  {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  }
                );
                setAuth(me.data.result);
            } catch (err) {
              console.log(err);
    
            }
        };

        if(!verifyToken(token)){
            localStorage.removeItem('token');
            navigate('/');
        }
        // refreshToken();
        getData();
        getCart();
        auth();

    }, []);

    return (
        <div>
            <Navbar cartState={cartState} UpdatedCartState={setCartState} />
                {/* <div
                    style={{
                        height: '80vh',
                        position: 'relative',
                        backgroundImage: `url(${maintenanceImg})`
                    }}
                >
                    <ParagraphText>
                        Fitur Pre Order sedang dalam masa development
                    </ParagraphText>
                </div> */}
                <PoComponent
                    data={data}
                    authData={authData}
                    opData={opData}
                    updatedData={setData}
                    updatedPoLink={setOpData}
                />
            <FooterNav />
        </div>
    )
};

export default PreOrder;

